import React from "react";
import { Tabs, Tab, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(theme => ({
  notSelected: {
    color: theme.palette.text.secondary
  },
  root: {
    borderTop: "none"
  }
}));

const SupportTabs = ({ tab, tabs, onChange }) => {
  const classes = useStyles();

  return (
    <Tabs
      classes={{ root: classes.root }}
      value={tab}
      onChange={(ev, newTab) => onChange(newTab)}
      indicatorColor="primary"
      textColor="primary"
    >
      {(tabs || []).map(tabName => (
        <Tab
          key={tabName}
          classes={{
            root: classes.tab,
            textColorPrimary: classes.notSelected
          }}
          label={<Typography>{tabName}</Typography>}
        />
      ))}
    </Tabs>
  );
};

export default SupportTabs;
